import { PersonaCategoriaTipoCategoriaModel } from "./persona-categoria-tipo-categoria.model";

export class PersonaCategoriaTipoModel {
  id: number = 0;
  codigo: string = '';
  acronimo: string = '';
  nombre: string = '';
  descripcion: string = '';
  categoriaId: number = 0;
  categoria: PersonaCategoriaTipoCategoriaModel = new PersonaCategoriaTipoCategoriaModel();

  constructor() { }
}
